import { useEffect, useState } from 'react'
import { api, HealthSummary } from '../api/projects'

function HealthCards() {
  const [health, setHealth] = useState<HealthSummary[]>([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState('')

  useEffect(() => {
    api.getHealth()
      .then(setHealth)
      .catch((e) => setError(e.message))
      .finally(() => setLoading(false))
  }, [])

  if (loading) return <div>Loading health...</div>
  if (error) return <div style={{ color: 'red' }}>Error: {error}</div>

  const statusEmoji: Record<string, string> = {
    green: '🟢',
    yellow: '🟡',
    red: '🔴',
    paused: '⏸️',
    unknown: '⚪',
  }

  const statusLabel: Record<string, string> = {
    green: 'On Track',
    yellow: 'In Progress',
    red: 'At Risk',
    paused: 'Paused',
    unknown: 'Unknown',
  }

  return (
    <div style={{ padding: '1rem' }}>
      <h2>Project Health</h2>
      {health.length === 0 && <p>No projects to display.</p>}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(250px, 1fr))', gap: '1rem' }}>
        {health.map((h) => (
          <div
            key={h.id}
            style={{
              border: '1px solid #ccc',
              borderRadius: '8px',
              padding: '1rem',
              background:
                h.status === 'red'
                  ? '#fff5f5'
                  : h.status === 'yellow'
                  ? '#fffbeb'
                  : '#f0fdf4',
            }}
          >
            <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', marginBottom: '0.5rem' }}>
              <span style={{ fontSize: '1.5rem' }}>{statusEmoji[h.status] || '⚪'}</span>
              <h3 style={{ margin: 0, fontSize: '1.1rem' }}>{h.name}</h3>
            </div>
            <p style={{ margin: '0.25rem 0', fontSize: '0.85rem', color: '#555' }}>
              {statusLabel[h.status] || 'Unknown'}
            </p>
            <div style={{ display: 'flex', gap: '1rem', fontSize: '0.8rem', marginTop: '0.5rem' }}>
              <span>Total: {h.deliverables_total}</span>
              <span>Done: {h.deliverables_done}</span>
              {h.deliverables_at_risk > 0 && (
                <span style={{ color: '#dc2626', fontWeight: 'bold' }}>
                  At Risk: {h.deliverables_at_risk}
                </span>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}

export default HealthCards
